import {IOrder, IOrderUpdate} from 'types';
import {DELETE, GET, POST, PUT} from './fetcher';

export async function request_create_order(order: IOrder) {
	const resp = await POST('/v1/order/create', order);
	return resp;
}

export async function request_remove_order(order_id: string) {
	const resp = await DELETE('/v1/order', {order_id});
	return resp;
}

export async function request_close_order(order_id: string) {
	const resp = await POST('/v1/order/close', {order_id});
	return resp;
}

export async function request_cancel_order(order_id: string) {
	const resp = await POST('/v1/order/cancel', {order_id});
	return resp;
}

export async function request_grab_order(order_id: string) {
	const resp = await PUT('/v1/order', {order_id});
	return resp;
}

export async function query_order_states({queryKey}: {queryKey: [string, string[]]}): Promise<Record<string, IOrderUpdate>> {
	const order_ids = queryKey[1];
	const resp = await POST('/v1/order/state', {order_ids});
	return resp.data;
}

export async function query_orders(ids?: string[]): Promise<IOrder[]> {
	const resp = await POST('/v1/order', {ids});
	return resp.data.orders as IOrder[];
}

export async function query_closed_orders(): Promise<IOrder[]> {
	const resp = await GET('/v1/order/closed');
	return resp.data.orders as IOrder[];
}

export async function request_recover_order(exchange: string) {
	const resp = await POST('/v1/order/recover', {exchange});
	return resp;
}
